import { render, staticRenderFns } from "./CalculatePayroll.vue?vue&type=template&id=7d626230"
import script from "./CalculatePayroll.vue?vue&type=script&lang=js"
export * from "./CalculatePayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports